export default __webpack_public_path__ + "static/media/icestrike.ef3cda64.png";